import { useTranslation } from "react-i18next";
import { DropsButton, HStack, Text } from "shared/components/Spor";
import {
  openContactIt,
  StateContainer,
} from "shared/components/states/stateHelpers";
import ErrorStateIllustration from "shared/components/illustrations/errorStateIllustration.svg?react";

export const LargeErrorState = ({ onRetry }: { onRetry: () => void }) => {
  const { t } = useTranslation();

  return (
    <StateContainer
      backgroundColor="semantics.colorBackgroundBase"
      minHeight="545px"
      gap={6}
      padding={4}
      border
    >
      <ErrorStateIllustration width="160px" />

      <Text variant="md" maxWidth="700px" textAlign="center">
        {t(
          "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ta kontakt med IT.",
        )}
      </Text>
      <HStack gap="2" justifyContent="center">
        <DropsButton onClick={openContactIt} variant="tertiary">
          {t("Kontakt IT")}
        </DropsButton>
        <DropsButton size="md" variant="primary" onClick={onRetry}>
          {t("Last på nytt")}
        </DropsButton>
      </HStack>
    </StateContainer>
  );
};
